import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect } from 'react';
import { CustomLabel, Loadable } from '../../../common';
import CloseIcon from '@mui/icons-material/Close';
import { EllipsisText } from '../../../common/EllipsisText';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

function DependencyDialog(props) {
    const { open, oppsId, dependencies, getDependenciesPending, deletePendng, oppsName, canDelete,
        handleRefresh, actions: { setDependencyDialog, getOPPSDeleteDependencies, deleteOPPS, resetDependencies } } = props;

    const classes = useStyles();

    useEffect(() => {
        if (open && oppsId) {
            getOPPSDeleteDependencies(oppsId)
        }
    }, [open, oppsId, getOPPSDeleteDependencies]);

    const handleDialogClose = () => {
        setDependencyDialog(null);
        resetDependencies();
    }

    const handleDeleteCallback = () => {
        setDependencyDialog(null);
        handleRefresh(true);
    }

    const handleDelete = () => {
        if (dependencies.length > 0) return
        deleteOPPS(oppsId, handleDeleteCallback);
    }

    return (
        (<Dialog maxWidth='sm' fullWidth open={open} onClose={handleDialogClose}>
            <Loadable loading={getDependenciesPending || deletePendng}>
                <DialogTitle>
                    <Grid container>
                        <Grid item xs={11}>
                            <Typography variant="h6">
                                Dependencies ({oppsName})
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                aria-label="close"
                                className={classes.closeButton}
                                onClick={handleDialogClose}
                                size="large">
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>

                </DialogTitle>
                <DialogContent dividers>
                    <Grid>
                        {dependencies.length > 0 ?
                            <Typography>{canDelete ? 'Are you sure to delete OPPS with following dependencies?' : 'Following dependencies are found:'}</Typography> :
                            <Typography>No dependencies found. Click to delete</Typography>
                        }
                    </Grid>
                    {dependencies.length > 0 && <Grid className='pt-2'>
                        <ol className='lower-alpha'>
                            {dependencies?.map((item, index) =>
                                <li key={`key-${index}`}>
                                    <b>{item.name} </b>
                                    <Grid>
                                        <ul>
                                            {item?.dependents?.map((dep, pcIndex) => <li key={`contract-key-${pcIndex}`}>
                                                <CustomLabel label={`${dep.dependentType}(${dep.count.toString()})`} data={
                                                    <EllipsisText textArr={dep.names} />
                                                } />
                                            </li>)}
                                        </ul>
                                    </Grid>
                                </li>
                            )}
                        </ol>
                    </Grid>}
                </DialogContent>
                <DialogActions className='p-4'>
                    <Button variant="contained" onClick={handleDialogClose}>
                        Cancel
                    </Button>
                    {canDelete &&
                        <Button
                            onClick={handleDelete}
                            variant="contained"
                            disabled={getDependenciesPending || deletePendng}
                            color="primary"
                        >
                            Delete
                        </Button>
                    }
                </DialogActions>
            </Loadable >
        </Dialog>)
    );
}

export default DependencyDialog
